[
  {
    "id": 0,
    "title": "Selfservice point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "",
      "number": ""
    },
    "coords": [50.03989, 20.000748],
    "description": "self service near bus station..."
  },
  {
    "id": 1,
    "title": "Selfservice repair point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "Tadeusza Romanowicza",
      "number": 1
    },
    "coords": [50.049724, 19.964101],
    "description": "self service near Zablocie..."
  },
  {
    "id": 2,
    "title": "Selfservice repair point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "Aleja Pokoju",
      "number": 46
    },
    "coords": [50.065619, 19.98736],
    "description": "In front of main entrance Decathlon"
  },
  {
    "id": 3,
    "title": "Selfservice repair point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "Wielicka",
      "number": 76
    },
    "coords": [50.032946, 19.970942],
    "description": "In front of Apteka"
  },
  {
    "id": 4,
    "title": "Selfservice repair point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "Wielicka",
      "number": 8
    },
    "coords": [50.04203, 19.961829],
    "description": "In front Bike srvice 'Secesja'"
  },
  {
    "id": 5,
    "title": "Selfservice repair point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "Na Zjeździe",
      "number": 11
    },
    "coords": [50.047012, 19.955165],
    "description": "Near bike parking lot, in front of office building"
  },
  {
    "id": 6,
    "title": "Selfservice repair point",
    "type": "selfservice",
    "address": {
      "city": "Krakow",
      "street": "Marii Konopnickiej",
      "number": 0
    },
    "coords": [50.04365, 19.934625],
    "description": "Near 'Hilton Garden Inn'"
  }
]
